import React from 'react'
import { CardContainer, StyledTitle, StyledContent} from './styled'
import { Col, Row } from 'react-bootstrap'

const SideBySideCard = (props) => {
    return (
                <CardContainer>
                    <Col
                        lg={{
                            span: 6,
                            offset: 2
                        }}
                        xs={{
                            span: 10,
                            offset: 1
                        }}
                    >
                        <StyledTitle primary={props.primary}>
                            {props.title}
                        </StyledTitle>
                        <StyledContent primary={props.primary} dangerouslySetInnerHTML={{__html: props.content}}/>
                    </Col>
                </CardContainer>
            )
}

export default SideBySideCard